import {BaseService} from "@/api/baseService";
import type {PostAuthor} from "@/api/post";

export type Author<DateType = string> = PostAuthor<DateType>;

export class AuthorService extends BaseService {
    public static async getAll(): Promise<Author[]> {
        const response = await this.getData<Author[]>("/authors");
        return Array.isArray(response) ? response : [];
    }

    public static async getBySlug(slug: string): Promise<Author | undefined> {
        const response = await this.getData<Author[]>("/authors", {
            where: {
                slug: {
                    equals: slug,
                },
            },
        });
        if (!Array.isArray(response)) return undefined;
        return response[0];
    }
}
